import React, { useEffect, useCallback } from 'react';
import { Row, Col, Button, Form, DatePicker } from 'antd';
import moment from 'moment';

const DateType = ({
  question,
  selectedAnswer,
  buttonsState,
  onSubmitAnswer,
  selectedOption,
  setSelectedOption,
}) => {
  const [form] = Form.useForm();

  const getInitialMoment = (value) => {
    if (!value || value.trim() === '') return null;
    return moment(value, 'YYYY-MM-DD', true).isValid() ? moment(value, 'YYYY-MM-DD') : null;
  };

  const setFieldValue = useCallback(() => {
    const initialMoment = getInitialMoment(selectedAnswer);
    form.setFieldsValue({ date: initialMoment });
    setSelectedOption(initialMoment);
  }, [selectedAnswer, form, setSelectedOption]);

  const onFinish = (type) => {
    const dateValue = form.getFieldValue('date');
    const answerToSave = dateValue ? dateValue.format('YYYY-MM-DD') : '';
    onSubmitAnswer(type, answerToSave);
    form.resetFields();
  };

  const handleDateChange = (date) => {
    setSelectedOption(date ? date.format('YYYY-MM-DD') : '');
    form.setFieldsValue({ date });
  };

  const isDisabled = () => {
    return buttonsState.isCurrentLastQuestion
      ? !selectedOption
      : buttonsState.lastQuestion && buttonsState.questionsUnanswered;
  };

  useEffect(() => {
    form.resetFields();
    setFieldValue();
  }, [setFieldValue, form]);

  return (
    <Row justify="center">
      <Form
        form={form}
        style={{ width: '100%' }}
      >
        <Col md={24} className="options-wrapper p-40 mt-40 mb-80">
          <Row justify="center">
            <Col md={24}>
              <h2
                className="text-center mt-10 mb-50"
                dangerouslySetInnerHTML={{ __html: question.title && question.title }}
              />
            </Col>
            <Col md={10}>
              <Form.Item name="date" className="mb-0">
                <DatePicker
                  style={{ width: '100%', fontSize: '22px' }}
                  size="large"
                  format="YYYY-MM-DD"
                  placeholder={question.title && question.title}
                  onChange={handleDateChange}
                  value={selectedOption}
                />
              </Form.Item>
            </Col>
          </Row>
        </Col>
        <Col md={24} className="mb-40">
          <Row>
            <Col md={5}>
              <Button
                className={'secondary-button'}
                size="large"
                onClick={() => onFinish('previus')}
                block
              >
                Anterior
              </Button>
            </Col>
            <Col md={buttonsState.isCurrentLastQuestion ? 12 : 14}></Col>
            <Col md={buttonsState.isCurrentLastQuestion ? 7 : 5} justify="end">
              <Button
                disabled={isDisabled()}
                className={isDisabled() ? 'button-disabled' : ''}
                type="primary"
                size="large"
                onClick={() => onFinish('foward')}
                block
              >
                {buttonsState.isCurrentLastQuestion ? 'Terminar cuestionario' : 'Siguiente'}
              </Button>
            </Col>
          </Row>
        </Col>
      </Form>
    </Row>
  );
};

export default DateType;
